import { Box, Button, Text, useTheme } from '@ltvco/refresh-lib/theme';
import { Language, ArrowForward } from '@mui/icons-material';
import { useContext } from 'react';

import { ChatContext } from 'components/ChatBV/context';

interface TryWebSearchButtonProps {
  onClick?: () => void;
}

export const TryWebSearchButton = ({ onClick }: TryWebSearchButtonProps) => {
  const theme = useTheme();
  const { useWebSearch, setUseWebSearch } = useContext(ChatContext);

  const handleClick = () => {
    setUseWebSearch(!useWebSearch);
    onClick?.();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        gap: 1.2,
        flexWrap: 'wrap',
        width: '720px',
        marginBottom: 3,
        '@media (min-width: 420px)': {
          flexDirection: 'row',
          alignItems: 'center',
        },
      }}
    >
      <Text
        variant="body2"
        sx={{
          color: theme.palette.text.primary,
          fontSize: '0.875rem',
          fontWeight: 400,
          whiteSpace: 'nowrap',
        }}
      >
        {useWebSearch
          ? 'Web search enabled for next message'
          : "Couldn't find what you are looking for?"}
      </Text>
      <Button
        variant="contained"
        onClick={handleClick}
        sx={{
          gap: 0.5,
          padding: '3px 8px',
          textTransform: 'none',
          backgroundColor: useWebSearch
            ? theme.palette.success.main
            : '#E5EEFF',
          color: useWebSearch ? '#FFFFFF' : theme.palette.primary.main,
          fontSize: '0.875rem',
          fontWeight: 400,
          borderRadius: '100px',
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: useWebSearch
              ? theme.palette.success.dark
              : theme.palette.primary.light,
            boxShadow: 'none',
          },
        }}
      >
        <Language sx={{ fontSize: '1.125rem' }} />
        <span>Try Web Search</span>
        <ArrowForward sx={{ fontSize: '1.125rem' }} />
      </Button>
    </Box>
  );
};
